module.exports = __webpack_public_path__ + "static/media/menu16.14e2f117.jpg";